import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../auth-service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  email = '';
  password = '';
  constructor(private authService: AuthService) { }

  ngOnInit() {
  }

  onSignup(signupForm: NgForm) {
      const email = signupForm.value.email;
      const password = signupForm.value.password;
      this.authService.signupUser(email, password);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/register/register.component.ts